module.exports = __webpack_public_path__ + "static/img/carregando-mensagens.7b20394.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carregando-mensagens.gif
// module id = 132
// module chunks = 1